import Navbar from '@/components/feature/Navbar';
import ContactFooter from '@/pages/home/components/ContactFooter';
import ProcessHero from './components/ProcessHero';
import ProcessSteps from './components/ProcessSteps';
import ProcessNotice from './components/ProcessNotice';

export default function ProcessPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <main>
        <ProcessHero />
        <ProcessSteps />
        <ProcessNotice />
      </main>
      <ContactFooter />
    </div>
  );
}
